module.exports = __webpack_public_path__ + "static/media/man-user.0e5d8320.svg";